import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [
  {
    "id": "last-name",
    "type": "input",
    "label": "姓",
    "size": 50,
    "model": "lastName",
    "validation": {
      required
    },
    "errorMsg": [
      "姓を正しく入力してください。"
    ]
  },
  {
  "id": "first-name",
  "type": "input",
  "label": "名",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "	名を正しく入力してください。"
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "ご連絡先電話番号",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "電話番号には半角数字のみ入力してください。	",
    "電話番号には半角数字のみ入力してください。	"
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "ご連絡先電話番号（2）",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "電話番号には半角数字のみ入力してください。	"
  ]
},
{
  "id": "postal-code",
  "type": "input",
  "label": "郵便番号",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "郵便番号を入力してください。"
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "国 / 地域 ",
  "size": 50,
  "model": "countryName"
},

{
  "id": "state",
  "type": "input",
  "label": "都道府県",
  "size": 50,
  "model": "state"
},
{
  "id": "city",
  "type": "input",
  "label": "市・区・郡・（町）",
  "size": 50,
  "model": "city"
},
{
  "id": "address1",
  "type": "input",
  "label": "番地",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "住所を記入してください。"
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "ビル名・部屋番号等 (お届け先が法人様等の場合は、会社名、ご部署等もご記載ください。)",
  "size": 100,
  "model": "address2"
}



]